import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="user-picker"
// A type-to-filter single-user picker for the admin queue forms. Selecting an
// option fills the hidden user_ids field with that user's id; editing the text
// again clears it so a stale id can't be submitted.
export default class extends Controller {
    static targets = ["input", "hidden", "panel", "option"]

    connect() {
        this.activeIndex = -1
    }

    open() {
        this.filter()
    }

    close() {
        this.hideTimeout = setTimeout(() => this.panelTarget.classList.add("hidden"), 120)
    }

    filter() {
        this.hiddenTarget.value = ""
        const query = this.inputTarget.value.trim().toLowerCase()
        let visible = 0
        this.optionTargets.forEach((option) => {
            const match = option.dataset.search.toLowerCase().includes(query)
            option.classList.toggle("hidden", !match)
            option.classList.remove("bg-sky-50")
            if (match) visible++
        })
        this.activeIndex = -1
        this.panelTarget.classList.toggle("hidden", visible === 0)
    }

    select(e) {
        clearTimeout(this.hideTimeout)
        this.pick(e.currentTarget)
    }

    keydown(e) {
        const options = this.optionTargets.filter((o) => !o.classList.contains("hidden"))
        if (options.length === 0) return

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault()
            this.open()
            const step = e.key === "ArrowDown" ? 1 : -1
            this.activeIndex = (this.activeIndex + step + options.length) % options.length
            options.forEach((o, i) => o.classList.toggle("bg-sky-50", i === this.activeIndex))
            options[this.activeIndex].scrollIntoView({block: "nearest"})
        } else if (e.key === "Enter") {
            e.preventDefault()
            if (this.activeIndex >= 0) this.pick(options[this.activeIndex])
        } else if (e.key === "Escape") {
            this.panelTarget.classList.add("hidden")
        }
    }

    pick(option) {
        this.hiddenTarget.value = option.dataset.id
        this.inputTarget.value = option.dataset.label
        this.panelTarget.classList.add("hidden")
    }
}
